module.exports = __webpack_public_path__ + "static/media/text-block-video-1.99755850.png";